export default [
    {
        path: '/website-pages',
        props: true,
        component: () => import('@/views/WebsitePage'),
        children: [
            {
                path: ':webpageId',
                component: () => import('@/components/WebsitePage/Show'),
                props: true,
            },
            {
                path: 'version/:versionId',
                component: () => import('@/components/WebsitePage/Version'),
                props: true,
            },
        ]
    },


];
